import IconButton from "shared/components/forms/buttons/IconButton";

const Header = ({
  isFirstStep,
  onBackHandler,
}: {
  isFirstStep: boolean;
  onBackHandler: () => void;
}) => (
  <div className="questionnaire-header">
    <IconButton
      isEnable={!isFirstStep}
      onClickHandler={onBackHandler}
      iconName="ArrowLeftIcon"
      id="back-button"
    />
    <IconButton iconName="QuestionMarkBubbleIcon" />
  </div>
);

export default Header;
